import { useScrollTrigger } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { setupCurrentOriginUrl } from 'utils/contentUtils';

const isInsideMenuItems = (target) => {
  return (
    target?.closest?.('.dektop_main_menu_item') != null ||
    target?.closest?.('.desktop_main_menu') != null ||
    target?.closest?.('.main_menu_border') != null
  );
};

const useBottomHeader = (menuItems) => {
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 40 });
  const menuItemsRef = useRef();
  const [activeClickElement, setActiveClickElement] = useState(null);
  const [activeHoverElement, setActiveHoverElement] = useState(null);

  const clearActiveElement = () => {
    setActiveClickElement(null);
    setActiveHoverElement(null);
  };

  const onMouseEnterSetActiveItem = (it) => {
    if (it !== null && activeHoverElement?.id !== it.id) {
      setActiveHoverElement(it);
    }
  };

  const onMouseLeaveClearActiveItem = (e) => {
    if (activeHoverElement == null || isInsideMenuItems(e?.relatedTarget)) {
      return;
    }
    setActiveHoverElement(null);
  };

  const onMenuItemClickSetActiveItem = (e, it) => {
    if (it == null) {
      return;
    }

    if (Array.isArray(it.list) && it.list.length > 0) {
      e.preventDefault();
      if (activeClickElement?.id !== it.id) {
        setActiveClickElement(it);
      } else {
        setActiveClickElement(null);
      }
    } else if (setupCurrentOriginUrl(it.url) == null) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (activeClickElement == null) {
      return;
    }

    const onClick = (e) => {
      if (!isInsideMenuItems(e?.target) && activeClickElement != null) {
        setActiveClickElement(null);
      }
    };
    window.addEventListener('click', onClick);
    return () => {
      window.removeEventListener('click', onClick);
    };
  }, [activeClickElement]);

  useEffect(() => {
    clearActiveElement();
  }, [menuItems]);

  return {
    trigger: trigger,
    menuItemsRef: menuItemsRef,
    activeElement: activeClickElement ?? activeHoverElement,
    onMouseEnterSetActiveItem: onMouseEnterSetActiveItem,
    onMouseLeaveClearActiveItem: onMouseLeaveClearActiveItem,
    onMenuItemClickSetActiveItem: onMenuItemClickSetActiveItem,
  };
};
export default useBottomHeader;
